<template>
    <div class="conntiner">
        <div class="searchBox">
            <a-space direction="vertical" v-if="false">
                <a-range-picker v-model:value="value3" @change="onChange">
                    <template #suffixIcon>
                        <SmileOutlined />
                    </template>
                </a-range-picker>
            </a-space>

            <a-space  class=" mr-10">
                <a-input class="keyword"  allowClear v-model:value="pageData.search_key"  @pressEnter="changePage"
                    placeholder="请输入关键字" />
            </a-space>
            <a-space  class=" mr-10">
                <a-select ref="select" allowClear v-model:value="pageData.marker_status" @change="changePage"   placeholder="请选择告警类型">
                    <a-select-option  :value="1">正常</a-select-option>
                    <a-select-option  :value="0">误报</a-select-option>
                    <!-- <a-select-option  v-for="item in modelList" :key="item.modelNo" :value="item.modelNo">{{item.name}}</a-select-option> -->
                </a-select>
            </a-space>
            <a-space class=" mr-10">
              <a-range-picker
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="x"
                  :placeholder="['开始时间', '结束时间']"
                  v-model:value="pageData.times"
              />
            </a-space>
            <a-button  type="primary" @click="changePage">查询</a-button>
            <a-button  style="margin-left: 10px" @click="()=>onSign()" :disabled="!selectedRowKeys.length">批量标记<span v-if="selectedRowKeys.length">({{selectedRowKeys.length}})</span></a-button>
        </div>

        <div class="tablebox">
          <!-- <div class="mb10">
            <a-button size="small" @click="()=>onSign()" :disabled="!selectedRowKeys.length">批量标记</a-button>
          </div> -->
            <a-table :scroll="{ y: 540 }"  :row-selection="rowSelection" row-key="id" :data-source="dataList" align="center" placeholder="请选择告警类型" :pagination="paginationProp"  @change="refreshData">
                <a-table-column  align="center" key="modelName" title="告警类型" data-index="modelName" />
                <a-table-column  align="center" key="alarmDate" title="告警时间" data-index="alarmDate" />
                <a-table-column :customCell="setCellStyle" align="center" key="alarmImage" title="告警图片" data-index="alarmImage">
                    <template #default="{ record }">
                      <img :src="record.alarmImage" style="width:30px;height:30px;" @click="openImages(record)" alt="">
                    </template>
                </a-table-column>
                <a-table-column  align="center"  title="告警视频" v-if="false">
                    <template #default="{ record }">
                        <span style="color: #0E8AE9;" @click="playVideo(record)">
                            <VideoCameraOutlined />
                        </span>
                    </template>
                </a-table-column>
                <a-table-column key="action" title="操作">
                    <template #default="{ record }">
                        <a-button type="primary" size="small" @click="handleMark(record)">标记</a-button>
                        <a-button :class="{'ml10':true,flying:record.id === alarmId }" :loading="rowLoading[record.id]" size="small" :disabled="!!alarmId" @click="flyTo(record)">{{record.id === alarmId?'正在执行':'飞往此处'}}</a-button>
                    </template>
                </a-table-column>
            </a-table>
        </div>

        <div class="vediobox" v-if="videoShow">
            <div class="title">
                <span>告警视频</span>
                <img @click="videoShow = false;closeVideo()" :src="Close">
            </div>
            <div class="grid2 video-box">
                <player ref="pushVideoPlayUrl" style="height: 50vh;" :videoUrl="videoRow.pushVideoPlayUrl" fluent autoplay @screenshot="shot"
                            @destroy="destroyJessibuca"/>
                <player ref="computingVideoPlayUrl" style="height: 50vh;margin-left: 10px;" :videoUrl="videoRow.computingVideoPlayUrl" fluent autoplay @screenshot="shot"
                            @destroy="destroyJessibuca"/>

            </div>
        </div>
    </div>
    <!-- 图片预览 -->
  <imagePreview :isShow="isShowImgPanel" :isSign="true" :info="imageInfo" :list="dataList" @onClose="closeImagePanel" type="alarm"/>
</template>
<script  setup lang="ts">
import { ref, reactive, onMounted, h } from 'vue'
import Close from '/@/assets/icons/audio/close.png'
import { SmileOutlined, VideoCameraOutlined } from '@ant-design/icons-vue'
import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import {
  getAlgorithmAlarmListPageVo,
  getAlgorithmModelListPageVo,
  flagMisreportByAlgorithmAlarm,
  setAlarmStatus,
  BatchSetAlarmStatus
} from '/@/api/alarm'
import player from '/@/components/jessibuca.vue'
import { TableState } from 'ant-design-vue/lib/table/interface'
import imagePreview from '/@/components/imagePreview/index.vue'
import { CURRENT_CONFIG as config } from '/@/api/http/config'
import { message, Modal } from 'ant-design-vue'
import { getAlarmDataListPageVo, getAlarmId, toCheckPoint } from '/@/api/manage'
import { ELocalStorageKey } from '/@/types'

const videoRow = ref({
  pushVideoPlayUrl: '',
  computingVideoPlayUrl: ''
})
const value3 = ref([])
const videoShow = ref(false)
const selectedRowKeys = ref<(string | number)[]>([])
const selectedRows = ref<any[]>([])
const rowSelection = reactive({
  selectedRowKeys,
  onChange: (keys: (string | number)[], rows: any[]) => {
    selectedRowKeys.value = keys
    selectedRows.value = rows
  },
})
const setCellStyle = () => {
  return {
    style: {
      padding: '0 16px',
    },
  }
}
const rowLoading = reactive({})
const dataList = ref([])
const isShowImgPanel = ref(false)
const imageInfo = ref({})
function closeImagePanel () {
  isShowImgPanel.value = false
  getList()
}
function openImages (record) {
  isShowImgPanel.value = true
  imageInfo.value = record
}
const onChange = (value, dateString) => {
  console.log('Selected Time: ', value)
  console.log('Formatted Selected Time: ', dateString)
}
const playVideo = (val) => {
  videoShow.value = true
  videoRow.value = {
    pushVideoPlayUrl: val.pushVideoPlayUrl,
    computingVideoPlayUrl: val.computingVideoPlayUrl
  }
}
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)
const droneSn = localStorage.getItem('drone_sn')
const alarmId = ref('')
const pageData = reactive(
  {
    page_num: 1,
    page_size: 10,
    times: null,
    region_code: Number(localStorage.getItem('map_regin_code')),
    workspace_id: workspaceId,
    marker_status: 1
    // searchKey: '',
    // modelName: '',
    // modelNo: '',
    // customerName: config.customerNo,
    // misreport: 0
  }
)
const modelList = ref([])
const allModelNo = ref('')
const paginationProp = reactive({
  showQuickJumper: true,
  showSizeChanger: false,
  showTotal: (total: number) => `共${total}条记录`,
  pageSize: 10,
  current: 1,
  total: 0
})

onMounted(() => {
  getAlarm()
  getList()
})
function getAlarm () {
  getAlarmId({
    workspace_id: workspaceId,
    drone_sn: droneSn
  }).then(res => {
    if (res.code === 0) {
      alarmId.value = res.data
    }
  })
}
function flyTo (record) {
  rowLoading[record.id] = true
  toCheckPoint({
    workspace_id: workspaceId,
    drone_sn: droneSn,
    alarm_id: record.id
  }).then(res => {
    if (res.code === 0) {
      message.success('执行成功')
      getList()
      getAlarm()
    }
  }).finally(() => {
    rowLoading[record.id] = false
  })
}
function onSign () {
  Modal.confirm({
    title: h('div', { style: 'color:#ffffff;' }, '是否标记以下图片误报'),
    onOk () {
      BatchSetAlarmStatus({ ids: selectedRowKeys.value, marker_status: 0 }).then(res => {
        if (res.code === 0) {
          message.success('标记成功')
          selectedRows.value = []
          selectedRowKeys.value = []
          getList()
        }
      })
    },
    onCancel () {
      console.log('Cancel')
    }
  })
}
function handleMark (record) {
  Modal.confirm({
    title: h('div', { style: 'color:#ffffff;' }, '是否标记该图片误报'),
    onOk () {
      setAlarmStatus({ id: record.id, marker_status: 0 }).then(res => {
        if (res.code === 0) {
          message.success('标记成功')
          getList()
        }
      })
    },
    onCancel () {
      console.log('Cancel')
    }
  })
}
function refreshData (page) {
  pageData.page_num = page.current
  //   pageData.pageSize = page?.pageSize!
  getList()
}
function changePage () {
  pageData.page_num = 1
  if (!pageData.model_no) {
    pageData.model_no = allModelNo.value
  }
  pageData.start_time = pageData?.times?.[0] || ''
  pageData.end_time = pageData?.times?.[1] || ''
  getList()
}
function getList () {
  getAlarmDataListPageVo(pageData).then(res => {
    if (res.code === 0) {
      paginationProp.total = res.data.pagination.total
      paginationProp.current = res.data.pagination.page
      dataList.value = res.data.list
      dataList.value.forEach(el => {
        el.object_keys = el.alarmImage
        if (el.latitude) {
          el.lat = el.latitude
          el.lng = el.longitude
        } else {
          el.lat = '0.0'
          el.lng = '0.0'
        }
      })
    }
  })
}

function closeVideo () {
  videoRow.value = {
    pushVideoPlayUrl: '',
    computingVideoPlayUrl: ''
  }
}
function destroyJessibuca (idx) {
  console.log(idx)
  this.clear(idx)
}
function clear (idx) {
  const dataStr = window.localStorage.getItem('playData') || '[]'
  const data = JSON.parse(dataStr)
  data[idx - 1] = null
  console.log(data)
  window.localStorage.setItem('playData', JSON.stringify(data))
}
function shot (e) {
  // console.log(e)
  // send({code:'image',data:e})
  const base64ToBlob = function (code) {
    const parts = code.split(';base64,')
    const contentType = parts[0].split(':')[1]
    const raw = window.atob(parts[1])
    const rawLength = raw.length
    const uInt8Array = new Uint8Array(rawLength)
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i)
    }
    return new Blob([uInt8Array], {
      type: contentType
    })
  }
  const aLink = document.createElement('a')
  const blob = base64ToBlob(e) // new Blob([content]);
  const evt = document.createEvent('HTMLEvents')
  evt.initEvent('click', true, true) // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
  aLink.download = '截图'
  aLink.href = URL.createObjectURL(blob)
  aLink.click()
}
</script>

<style lang="scss" scoped>
.video-box{
  width: 100%;
  margin-top: 10px;
}
.conntiner {
    .tablebox {
        margin-top: 20px;
        // height: 960px;
        width: 100%;

    }
    .flying{
      background-color: $alarm;
      color: #FFFFFF;
      &:hover{
        background-color: $alarm;
      }
    }
    .vediobox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 70%;
        min-height: 523px;
        background: #3c3c3e;
        padding: 23px 25px 35px 20px;
        box-sizing: border-box;
        .title {
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            position: relative;
            img {
                position: absolute;
                width: 21px;
                height: 21px;
                right: 0;
                top: 0;
            }
        }
        .video {
            margin-top: 18px;
            width: 805px;
            height: 430px;
            #videobox {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
